import React, { memo, useCallback, useMemo } from "react";
import colors from "app/colors";
import { AtMentionLockedIcon, AtSignIcon } from "modules/icons";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import { CALLOUT_KEY } from "modules/utils/Constants";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { MessageThreadFragment } from "gql/graphql";

interface IProps {
  draftId: string;
  appendText: (value: string) => void;
  messageThread?: MessageThreadFragment;
}

const ComposeBottomToolbarCalloutButton = ({
  draftId,
  appendText,
  messageThread,
}: IProps) => {
  const { draft, isDraftLoaded, bottomButtonTypes } = useMessageThreadDraft({
    draftId,
  });

  const isLocked = messageThread?.isLocked ?? draft?.isLocked ?? false;

  const onClick = useCallback(() => {
    appendText(CALLOUT_KEY);
  }, [appendText]);

  const title = useMemo(() => {
    if (isLocked) {
      return "This conversation is set to “Private”  to prevent anyone in the thread from adding users and groups to it.";
    }
    return "Mention someone";
  }, [isLocked]);

  const icon = useMemo(() => {
    if (isLocked) {
      return <AtMentionLockedIcon fill={colors.gray40} boxSize={5} />;
    }
    return <AtSignIcon fill={colors.gray40} boxSize={5} />;
  }, [isLocked]);

  if (!draft || !isDraftLoaded) return null;

  if (!bottomButtonTypes.includes("mention")) {
    return null;
  }

  return (
    <CircularIconButton
      title={title}
      aria-label="Mention someone"
      size="xs"
      variant="ghost"
      color={colors.gray40}
      icon={icon}
      onClick={onClick}
      tabIndex={-1}
    />
  );
};

export default memo(ComposeBottomToolbarCalloutButton);
